import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonUtilService } from 'app/services/commonUtil.service';
import { ReportService } from 'app/services/report.service';
import { SpinnerService } from 'app/services/spinner.service';

@Component({
  selector: 'ms-new-visura-request',
  templateUrl: './new-visura-request.component.html',
  styleUrls: ['./new-visura-request.component.css']
})
export class NewVisuraRequestComponent implements OnInit {

  submitted = false;
  error = false;
  success: Boolean = false;
  showCervedApis : Boolean = true;
  requestVisuraForm: FormGroup;
  requestNumber: any;
  uuid: any;
  data: any;
  minDate: any;
  maxDate: any;
  modalReference: any;

  constructor(
    private router: Router,
    private reportService: ReportService,
    private route: ActivatedRoute,
    private commonUtilService: CommonUtilService,
    private formBuilder: FormBuilder,
    public datepipe: DatePipe,
    private spinnerService: SpinnerService,
    private modalService: NgbModal) { }

  ngOnInit(): void {

    this.spinnerService.start();

    this.commonUtilService.translateLang("HRWE.PAGE_TITLE.CANDIDATE_DETAIL");

    var today = new Date();
    this.maxDate = this.datepipe.transform(today.setFullYear(today.getFullYear() - 18), 'yyyy-MM-dd');
    this.minDate = this.datepipe.transform(today.setFullYear(today.getFullYear() - 68), 'yyyy-MM-dd');

    this.requestVisuraForm = this.requestVisuraFormBuilder(this.formBuilder);

    this.reportService.initReport().subscribe(data => {
      this.data = data;
      this.requestVisuraForm = this.requestVisuraFormBuilder(this.formBuilder);
      this.spinnerService.stop();
    });
  }

  get f() { return this.requestVisuraForm.controls; }

  get val() { return this.requestVisuraForm.value; }

  requestVisuraFormBuilder = (formBuilder: FormBuilder) => {
    return formBuilder.group({
      requestNumber: [this.data && this.data.requestNumber ? this.data.requestNumber : '', [Validators.required]],
      firstName: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
      codiceFiscale: ['', [Validators.required, Validators.pattern('^[A-Za-z0-9]{16}$')]],
      dateOfBirth: ['', [Validators.required]],
      via: ['', [Validators.required]],
      indirizzo: ['', [Validators.required]],
      civico: ['', [Validators.required]],
      cap: ['', [Validators.required, Validators.pattern(/^-?(0|[0-9]\d*)?$/)]],
      provincia: ['', [Validators.required, Validators.pattern('^[A-Za-z]{2,3}$')]],
      citta: ['', [Validators.required]],
      callCrifAndCribis : [false],
      callCerved : [true],
      callCervedCensusCellByAddress : [true],
      callCervedEstimationAdvanced : [true],
      callCervedEventNegativityDetails : [true],
      callCervedEventNegativityFlags : [true],
      callCervedPersonCGS : [true],
      callCervedTraversal : [true]
    });
  }

  onSubmit() {

    this.spinnerService.start();

    this.success = false;
    this.submitted = true;
    this.error = false;

    if (this.requestVisuraForm.invalid) {
      this.commonUtilService.findInvalidControls(this.requestVisuraForm);
      this.spinnerService.stop();
      return;
    }

    let dataJSON = {
      requestNumber: this.val.requestNumber,
      firstName: this.val.firstName,
      lastName: this.val.lastName,
      email: 'N.D.',
      codiceFiscale: this.val.codiceFiscale,
      dateOfBirth: this.val.dateOfBirth,
      via: this.val.via,
      indirizzo: this.val.indirizzo,
      civico: this.val.civico,
      cap: this.val.cap,
      provincia: this.val.provincia,
      citta: this.val.citta,
      callCrifAndCribis : this.val.callCrifAndCribis,
      callCerved : this.val.callCerved,
      callCervedCensusCellByAddress : this.val.callCervedCensusCellByAddress,
      callCervedEstimationAdvanced : this.val.callCervedEstimationAdvanced,
      callCervedEventNegativityDetails : this.val.callCervedEventNegativityDetails,
      callCervedEventNegativityFlags : this.val.callCervedEventNegativityFlags,
      callCervedPersonCGS : this.val.callCervedPersonCGS,
      callCervedTraversal : this.val.callCervedTraversal
    }
    console.log(dataJSON);
    
    this.reportService.createCandidateVisura(dataJSON).subscribe(data => {
      this.router.navigate([`/report/${data.requestNumber}/candidate/detail/${data.candidates[0].uuid}`]);
      this.spinnerService.stop();
    }, err => {
      this.error = true;
      this.spinnerService.stop();
    });
  }

  getConfirmation() {
    let modalElem = <HTMLInputElement>document.querySelector("#launchModal");
    modalElem.click();
  }

  open(content) {
    this.modalReference = this.modalService.open(content);
    this.modalReference.result.then(result => {
      if (result === '1') {
        this.onSubmit();
      }
      this.modalReference.close();
    });

  }

  showOrHideCervedApiList($event) {
    if ($event.target.checked) {
      this.showCervedApis = true;
    } else {
      this.showCervedApis = false;
    }
    //console.log(this.showCervedApis);
  }

}
